import { render } from "./DnaSystem.vue?vue&type=template&id=76276fad&scoped=true"
import script from "./DnaSystem.vue?vue&type=script&lang=js"
export * from "./DnaSystem.vue?vue&type=script&lang=js"

import "./DnaSystem.vue?vue&type=style&index=0&id=76276fad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76276fad"]])

export default __exports__